module.exports = "/_next/static/images/photoMihailUlinici-32b5fd8d11c3a84ba4881aef13d5012d.webp";